/**
 * Created by Administrador on 11/8/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('passengerTypeService', passengerTypeService);

    passengerTypeService.$inject = ['$http', 'CONFIG', 'messageService'];

    function passengerTypeService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_CONFIG_GENERAL + '/' + CONFIG.API + '/passengerTypes';
        var service = {
            getPassengerTypes: getPassengerTypes,
            getPassengerType: getPassengerType,
            getPassengerTypesDisabled: getPassengerTypesDisabled,
            disablePassengerType: disablePassengerType,
            updatePassengerType: updatePassengerType
        }

        return service;

        function getPassengerTypes(){
            return $http.get(urlBase +"?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPassengerType(id){
            return $http.get(urlBase + "/"+id+"?detailed=true")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPassengerTypesDisabled(group){
            return $http.get(urlBase +"/"+ group +"/listDisabled")
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function disablePassengerType(id) {
            return $http.put(urlBase + "/" + id +"/disable")
                .then(function (response) {
                    messageService.registerDisabled('')
                    return response;
                })
                .catch(function (error) {
                    messageService.registerDisabledError('');
                });
        }

        function updatePassengerType(passengerType, id){
            return $http.put(urlBase + "/" + id, passengerType)
                .then(function(){
                    messageService.registerUpdate('passengerTypes');
                }, function(){
                    messageService.registerUpdateError('');
                });
        }
    };

})();
